import React, { useEffect, useState, VFC } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Route } from 'react-router';
import { useHistory } from 'react-router-dom';
import { ROLES } from '../auth/enums/roles';
import { ROUTES } from './routes';
import * as AuthSelectors from '../auth/redux/authSelectors';
import AccessDenied from '../error/AccessDenied';

interface ProtectedRouteProps {
  component: React.ElementType;
  allowedRoles: Array<ROLES>;
  path: string;
}

const isAllowed = (AOne: any[], ATwo: any[]) => {
  for (const EOne of AOne) {
    if (ATwo.includes(EOne)) return true;
  }
  return false;
};

const ProtectedRoute: VFC<ProtectedRouteProps> = ({ component: Component, allowedRoles, ...rest }) => {
  const history = useHistory();
  const me = useSelector(AuthSelectors.me);
  const [redirect, setRedirect] = useState<boolean>(false);
  const [isAuthorized, setIsAuthorized] = useState<boolean>(false);
  useEffect(() => {
    if (me.id !== 0 && me.roles.length) {
      if (!isAllowed(allowedRoles, me.roles)) {
        history.push(ROUTES.ERROR_403);
        setRedirect(true);
      } else {
        setIsAuthorized(true);
      }
    }
  }, [me]);

  if (redirect) {
    return <Route {...rest} render={() => <Route component={AccessDenied} />} />;
  }
  if (isAuthorized) {
    return <Route {...rest} render={(props) => <Component {...props} />} />;
  }
  return null;
};

ProtectedRoute.propTypes = {
  component: PropTypes.func.isRequired,
  allowedRoles: PropTypes.array.isRequired,
};

export default ProtectedRoute;
